up.radio = (function () {
    const e = up.element;
    const config = new up.Config(() => ({
        hungrySelectors: ['[up-hungry]'],
        noHungrySelectors: ['[up-hungry=false]'],
        pollInterval: 30000,
    }));
    function hungrySteps(renderOptions) {
        let { hungry, origin, layer: renderLayer, meta } = renderOptions;
        let steps = { current: [], other: [] };
        if (!hungry)
            return steps;
        let hungrySelector = config.selector('hungrySelectors');
        const layerPreference = [renderLayer, ...renderLayer.ancestors, ...renderLayer.descendants];
        for (let elementLayer of layerPreference) {
            let hungries = up.fragment.all(elementLayer.element, hungrySelector, { layer: elementLayer });
            for (let element of hungries) {
                let selector = up.fragment.tryToTarget(element, { origin });
                if (!selector) {
                    up.warn('[up-hungry]', 'Ignoring untargetable fragment %o', element);
                    continue;
                }
                let ifLayer = e.attr(element, 'up-if-layer');
                let applicableLayers = ifLayer ? up.layer.getAll(ifLayer, { baseLayer: elementLayer }) : [elementLayer];
                let motionOptions = up.motion.motionOptions(element);
                let selectEvent = up.event.build('up:fragment:hungry', { log: false });
                let selectCallback = up.script.callbackAttr(element, 'up-on-hungry', { expandObject: ['newFragment', 'renderOptions'] });
                let step = Object.assign(Object.assign({ selector, oldElement: element, layer: elementLayer, origin }, motionOptions), { placement: 'swap', keep: true, maybe: true, meta,
                    selectEvent,
                    selectCallback, originalRenderOptions: renderOptions });
                if (applicableLayers.includes(renderLayer)) {
                    let list = renderLayer === elementLayer ? steps.current : steps.other;
                    list.push(step);
                }
            }
        }
        steps.other = up.fragment.compressNestedSteps(steps.other);
        return steps;
    }
    function startPolling(fragment, options = {}) {
        up.FragmentPolling.forFragment(fragment).forceStart(options);
    }
    function stopPolling(element) {
        up.FragmentPolling.forFragment(element).forceStop();
    }
    function pollOptions(fragment, options = {}) {
        const defaults = { background: true };
        const parser = new up.OptionsParser(fragment, options, { defaults });
        parser.number('interval', { default: config.pollInterval });
        parser.string('ifLayer', { default: 'front' });
        parser.include(up.link.requestOptions);
        parser.include(up.status.statusOptions);
        return options;
    }
    up.attribute('up-poll', function (fragment) {
        up.FragmentPolling.forFragment(fragment).onPollAttributeObserved();
    });
    up.macro('[up-flashes]', function (fragment) {
        e.setMissingAttrs(fragment, {
            'up-hungry': '',
            'up-if-layer': 'subtree',
            'up-keep': '',
            'role': 'alert',
        });
        fragment.addEventListener('up:fragment:keep', function (event) {
            if (!e.isEmpty(event.newFragment))
                event.preventDefault();
        });
    });
    return {
        config,
        hungrySteps,
        startPolling,
        stopPolling,
        pollOptions,
    };
})();
